import { login, getUserInfo, logout as logoutApi } from '@/api/user'
import { setToken, removeToken, getToken } from '@/utils/auth'

const state = {
    token: getToken(),
    user: null,
    permissions: [],
    menus: [],
    isSuperAdmin: false,
    isFetching: false,
    needForceChangePwd: localStorage.getItem('needForceChangePwd') === 'true'  // 新增：是否需要强制修改密码
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USER: (state, user) => {
        state.user = user

        const userId = user?.id || user?.userId || user?.uid

        if (user && userId) {
            const userToSave = {
                ...user,
                realName: user.realName || user.userName
            }
            localStorage.setItem('ShareWin-User', JSON.stringify(userToSave))
        } else {
            localStorage.removeItem('ShareWin-User')
        }
    },
    SET_MENUS: (state, menus) => {
        state.menus = menus
        if (menus && menus.length > 0) {
            localStorage.setItem('ShareWin-Menus', JSON.stringify(menus))
        }
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
        if (permissions && permissions.length > 0) {
            localStorage.setItem('ShareWin-Permissions', JSON.stringify(permissions))
        }
    },
    SET_SUPER_ADMIN: (state, isSuperAdmin) => {
        state.isSuperAdmin = isSuperAdmin
        localStorage.setItem('ShareWin-IsSuperAdmin', isSuperAdmin ? 'true' : 'false')
    },
    SET_FETCHING: (state, flag) => {
        state.isFetching = flag
    },
    // 新增：设置是否需要强制修改密码
    SET_NEED_FORCE_CHANGE_PWD: (state, need) => {
        state.needForceChangePwd = need
        if (need) {
            localStorage.setItem('needForceChangePwd', 'true')
        } else {
            localStorage.removeItem('needForceChangePwd')
        }
    }
}

const actions = {
    login({ commit }, userInfo) {
        const { userName, password, captchaKey, captchaCode } = userInfo
        return new Promise((resolve, reject) => {
            login({ userName, password, captchaKey, captchaCode }).then(response => {
                const { token, user, menus, needChangePwd, permissions, isSuperAdmin } = response.data
                commit('SET_TOKEN', token)
                commit('SET_USER', user)
                commit('SET_MENUS', menus || [])
                commit('SET_PERMISSIONS', permissions || [])
                commit('SET_SUPER_ADMIN', isSuperAdmin || false)
                // 【重要】设置是否需要强制修改密码
                commit('SET_NEED_FORCE_CHANGE_PWD', needChangePwd || false)
                setToken(token)
                localStorage.setItem('ShareWin-Token', token)
                localStorage.setItem('ShareWin-Token-Time', Date.now().toString())
                resolve({ needChangePwd })
            }).catch(error => {
                reject(error)
            })
        })
    },
    getUserInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            if (state.isFetching) {
                resolve({ permissions: state.permissions, menus: state.menus, user: state.user, isSuperAdmin: state.isSuperAdmin })
                return
            }

            if (state.menus && state.menus.length > 0) {
                resolve({ permissions: state.permissions, menus: state.menus, user: state.user, isSuperAdmin: state.isSuperAdmin })
                return
            }
            commit('SET_FETCHING', true)

            getUserInfo().then(response => {
                const responseData = response.data
                let user = null
                let permissions = []
                let menus = []
                let roles = null
                let isSuperAdmin = false

                // 后端返回的是 realName
                if (responseData.id && responseData.realName) {
                    user = responseData
                } else {
                    user = responseData.user
                    permissions = responseData.permissions || []
                    menus = responseData.menus || []
                    roles = responseData.roles
                    isSuperAdmin = responseData.isSuperAdmin || false
                }

                const userData = user ? { ...user, roles } : null
                commit('SET_USER', userData)
                commit('SET_PERMISSIONS', permissions)
                commit('SET_MENUS', menus)
                commit('SET_SUPER_ADMIN', isSuperAdmin)
                commit('SET_FETCHING', false)
                resolve({ permissions, menus, user: userData, isSuperAdmin })
            }).catch(error => {
                console.error('获取用户信息失败:', error)

                const savedMenus = localStorage.getItem('ShareWin-Menus')
                const savedUser = localStorage.getItem('ShareWin-User')
                const savedPermissions = localStorage.getItem('ShareWin-Permissions')
                const savedIsSuperAdmin = localStorage.getItem('ShareWin-IsSuperAdmin')

                if (savedMenus && savedUser) {
                    try {
                        const menus = JSON.parse(savedMenus)
                        const user = JSON.parse(savedUser)
                        const permissions = savedPermissions ? JSON.parse(savedPermissions) : []
                        const isSuperAdmin = savedIsSuperAdmin === 'true'

                        commit('SET_MENUS', menus)
                        commit('SET_USER', user)
                        commit('SET_PERMISSIONS', permissions)
                        commit('SET_SUPER_ADMIN', isSuperAdmin)
                        commit('SET_FETCHING', false)

                        resolve({ permissions, menus, user, isSuperAdmin })
                        return
                    } catch (e) {}
                }

                commit('SET_FETCHING', false)
                reject(error)
            })
        })
    },

    logout({ commit }) {
        return new Promise((resolve) => {
            const token = localStorage.getItem('ShareWin-Token')
            if (token) {
                fetch('/api/logout', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                }).catch(err => {

                })
            }

            commit('SET_TOKEN', '')
            commit('SET_USER', null)
            commit('SET_PERMISSIONS', [])
            commit('SET_MENUS', [])
            commit('SET_SUPER_ADMIN', false)
            commit('SET_NEED_FORCE_CHANGE_PWD', false)  // 新增：清除强制修改密码标志

            localStorage.removeItem('ShareWin-Token')
            localStorage.removeItem('ShareWin-Token-Time')
            localStorage.removeItem('ShareWin-User')
            localStorage.removeItem('ShareWin-Menus')
            localStorage.removeItem('ShareWin-Permissions')
            localStorage.removeItem('ShareWin-IsSuperAdmin')
            localStorage.removeItem('needForceChangePwd')  // 新增：清除强制修改密码标志

            removeToken()
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}